import { Subject } from 'rxjs';
import { BackendSubscriptionEvent } from '../interfaces/backend-subscription';

export class BackendSubscriptionService {
  events$ = new Subject<BackendSubscriptionEvent>();
}

export const backendSubscriptionService = new BackendSubscriptionService();
